import { useParams } from "react-router-dom";
import { FiUser } from "react-icons/fi";

import { actions, hasPermission } from "../../services/security";

import Card from "./../../Components/ui/card";
import UsuariosForm from "../../Components/usuarios/Usuarios-form.jsx";
import Header from "./../../Components/ui/header";

const UsuariosDetailPage = () => {
  const { id } = useParams();

  const action =
    id === "nuevo"
      ? "Crear"
      : hasPermission(actions.UsuariosEditar)
      ? "Editar"
      : "Ver";

  const title = `${action} Usuario`;
  const icon = <FiUser />;
  const breadcrumb = [
    { title: "Usuarios", url: "/usuarios" },
    { title: action, url: `/usuarios/${id}` },
  ];

  return (
    <Card>
      <Header title={title} icon={icon} breadcrumb={breadcrumb} />
      <UsuariosForm id={id} />
    </Card>
  );
};

export default UsuariosDetailPage;
